var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenLink24Dp = function SvgOpenLink24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.5V19.5H19V12.5H21V19.5C21 20.6 20.1 21.5 19 21.5H5C3.89 21.5 3 20.6 3 19.5V5.5C3 4.4 3.89 3.5 5 3.5H12V5.5H5ZM14 5.5V3.5H21V10.5H19V6.91L9.17 16.74L7.76 15.33L17.59 5.5H14Z",
    fill: "currentColor"
  })));
};

export { SvgOpenLink24Dp as ReactComponent };
export default __webpack_public_path__ + "1b62125a7e8a1f3f8a897c33a843f4d8.svg";